import { Inject, Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Category } from '../../shared/category/category.model';
import * as fromShared from '../../shared/process';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { State } from '../../store/reducers';
import * as fromUser from '../../user-info/store';
@Injectable({
    providedIn: 'root'
})
export class CategoriesService implements OnDestroy {
    constructor(
        private store: Store<State>,
        @Inject(LoggingService) private log: LoggingService
    ) {
        this.categories = new ReplaySubject<Array<Category>>();

        // TODO: how to subscribe just to UserProcessCategories?
        this.store
            .pipe(select(fromUser.getUser))
            .pipe(takeWhile(() => this.active))
            .subscribe(user => {
                this.log.verbose({
                    type: 'CategoriesService:user-subscribe',
                    user
                });
                this.categories.next(user.UserProcessCategories);
                this._categories = user.UserProcessCategories;
                // this.categories = user.UserProcessCategories;
                this._processesMain = user.UserProcessesMain;
            });
    }
    private categories: ReplaySubject<Array<Category>>;
    private _categories: Array<Category>;
    private _processesMain: Array<fromShared.Process>;
    private active = true;
    ngOnDestroy(): void {
        this.active = false;
    }
    /**
     * getCategories
     */
    public getCategories(): Array<Category> {
        // will this get updated when categories get's updated?  Probably need to convert to observable.
        return this._categories;
    }
    getProcessesMain(): Array<fromShared.Process> {
        return this._processesMain;
    }

    public getCategory(catId: number): Category {
        return this._categories[catId - 1];
    }

    public getProcess(catId: number, procId: number): fromShared.Process {
        const category = this.getCategory(catId);
        this.log.debug({
            type: 'CategoriesService:getProcess',
            catId,
            procId,
            category
        });
        const process = category.UserProcesses.filter(
            i => i.ProcessID === procId
        )[0];
        this.log.debug({ type: 'CategoriesService:getProcess', process });
        return process;
    }
    public updateStoreProcess(process: fromShared.Process) {
        this.store.dispatch(fromShared.clearProcess());
        this.store.dispatch(fromShared.upsertProcess({ process }));
    }
}
